import { combineReducers } from "redux";
import auth from "./auth";
import user from "./user";
import app from "./app";
import franchise from "./franchise";

export const rootReducers = combineReducers({
  auth,
  user,
  app,
  franchise,
});

export type RootState = ReturnType<typeof rootReducers>;
